export function calcMinPath(cy, startId = 'START', endId = 'END') {
    if (!cy) return []

    const startNode = cy.getElementById(startId)
    if (!startNode || startNode.empty()) return []

    let path = []
    const visited = new Set()
    const stack = [startNode]

    while (stack.length > 0) {
        const currentNode = stack.pop()

        if (visited.has(currentNode.id())) {
            // eslint-disable-next-line no-continue
            continue
        }
        visited.add(currentNode.id())
        path.push(currentNode)

        if (currentNode.id() === endId) {
            break
        }

        const neighbors = currentNode.neighborhood('node').filter((n) => !visited.has(n.id()))

        if (neighbors.length === 0) {
            path.pop()
            if (path.length > 0) {
                stack.push(path[path.length - 1])
            }
        } else {
            const nextNode = neighbors.reduce(
                (maxNode, neighbor) => (neighbor.data('freq') > maxNode.data('freq') ? neighbor : maxNode),
                neighbors[0],
            )
            stack.push(nextNode)
        }
    }

    if (path.length === 0 || path[path.length - 1].id() !== endId) {
        // If the greedy algorithm can't find a path, fallback to A*.
        const astar = cy.elements().aStar({
            root: startNode,
            goal: cy.getElementById(endId),
            weight: (n) => 1 / n.data('freq'),
            directed: true,
        })

        path = astar.path.map((node) => node)
    }

    return path
}

export function calcMinimumPercent({ minPathNodesCount, totalPathNodesCount }) {
    if (!totalPathNodesCount) return 0
    return Math.round((minPathNodesCount / totalPathNodesCount) * 100)
}
